import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ContactInformationOwnerType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';
import { patchBodyOwnerContactInformationQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyOwnerContactInformation/patchBodyOwnerContactInformationQueryFunction';

type MutationVariables = {
  id: string;
  formData: ContactInformationOwnerType;
};

export const patchBodyOwnerContactInformationQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => ({
  mutationKey: ['patch-Body-Contact-Information'],
  mutationFn: ({ id, formData }: MutationVariables) =>
    patchBodyOwnerContactInformationQueryFunction(id, formData),
});
